module.exports = "/_next/static/images/card-physical-43f60a6d2ee0c4be124978b5a9688ca6.svg";